"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IfLoggedInUser = void 0;
var _useToken = require("./useToken");
const IfLoggedInUser = ({
  children
}) => {
  const {
    isAnonymousUser
  } = (0, _useToken.useToken)();
  if (isAnonymousUser) {
    return null;
  }
  return children;
};
exports.IfLoggedInUser = IfLoggedInUser;
//# sourceMappingURL=IfLoggedInUser.js.map